import { createThunkRoutine } from 'redux-thunk-routine';
import { FETCH_USER_PROFILE, UPDATE_USER_PROFILE } from './action-types';

export const FetchUserProfileRoutine = createThunkRoutine(FETCH_USER_PROFILE);
export const UpdateUserProfileRoutine = createThunkRoutine(UPDATE_USER_PROFILE);
